import { Component, EventEmitter, Output, Signal, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-table-header-actions',
    templateUrl: './table-header-actions.component.html',
    styleUrls: ['./table-header-actions.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TableHeaderActionsComponent {
  public name = input<string>();
  @Output() public exportEvent = new EventEmitter<Signal<string | undefined>>();

  export(name: Signal<string | undefined>) {
    this.exportEvent.emit(name);
  }
}
